import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import Aux from '../../Aux';

class SearchInput extends Component {
	constructor() {
		super();

		this.state = {
			active: false,
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	handleInputChange(e) {
		const { history, onInputChange } = this.props;

		if (history.location.pathname !== '/my-files') {
			history.push('/my-files');
		}		
		onInputChange(e.target.value);
	}

	onFocus() {
		this.setState({active: true});
	}
	
	onBlur() {
		this.setState({active: false});
	}

	render() {
		const { search, onInputChange, history, ...rest } = this.props;
		const iconClass = cs("search-bar__search-icon material-icons", { "search-bar__search-icon--active": this.state.active })
		
		return (
			<Aux>
				<span className={iconClass}>search</span>
				<input 
					{...rest}
					type="text"
					value={search}
					onChange={this.handleInputChange} 
					onFocus={this.onFocus}
					onBlur={this.onBlur} />
		
				{search && <span className="search-bar__clear material-icons" onClick={() => onInputChange("")}>clear</span>}
			</Aux>
		);
	}
};

SearchInput.PropTypes = {
	search: PropTypes.string.isRequired,
	onInputChange: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
}

export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/common/search/SearchInput/index.js